
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buying-guides/second",
      function () {
        return require("private-next-pages/buying-guides/second.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buying-guides/second"])
      });
    }
  